import numeral from "numeral";

const merge_label_key = {
  expenese_home_items: "บ้าน",
  expenese_car_items: "ซื้อรถ",
  expenese_children_items: "ลูก",
  expenese_travel_items: "ท่องเที่ยว",
  expenese_collection_items: "ของสะสม",
  expenese_other_items: "รายจ่ายอื่นๆ",
  income_legacy_items: "รายรับจากมรดก",
  income_business_items: "ขายธุรกิจ",
  income_property_items: "รายรับจากอสังหาริม",
  income_other_items: "รายรับอื่นๆ",
  income_peryear: "รายรับ",
  remain_accumulate: "สินทรัพย์ลงทุน",
  outcome_peryear: "จ่ายผันแปร",
  out_come_stable: "จ่ายคงที่ (ไม่รวมหนี้)",
  outcome_total: "รวมรายจ่ายต่อปี ",
  pension_peryear: "บำนาญต่อปี",
  remain: "เงินคงเหลือ",
  income_investment: "ผลตอบแทนการลงทุน ",
  debt_shortterm_other: "หนี้ดอกลอย",
  debt_informal_shortterm: "หนี้นอกระบบ",
  debt_shortterm: "หนี้ระยะสั้น",
  debt_creditcard: "หนี้บัตรเครดิต",
  expenese_children_education: "การศึกษาบุตร",
  debt_car: "ยานพาหนะ",
  debt_place: "ที่อยู่อาศัย",
  debt_long_other: "หนี้ระยะยาวอื่นๆ",
};

// Generate filename with current date
export const generateFileName = (userData, planType) => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  const dateStr = `${day}${month}${year}`;
  const username = `${userData?.firstname} ${userData?.lastname}` || "User";
  return `${username}-retirement-${planType}-${dateStr}.xlsx`;
};

// Helper function to calculate period interest
const calcPeriodInterest = (item, index) => {
  let year = Math.floor(item?.period / 12);
  let lastYearMonth = item?.period % 12;
  if (index >= Math.ceil(item?.period / 12)) return 0;
  if (index < year) return item?.pay_permonth * 12;
  return item?.pay_permonth * lastYearMonth;
};

// Helper function to calculate period interest for informal debt
const calcPeriodInterestInformal = (item, index) => {
  let year = Math.floor(item?.number_of_days / 365);
  let lastYearMonth = item?.number_of_days % 30;
  if (index >= Math.ceil(item?.number_of_days / 365)) return 0;
  if (index < year) return item?.pay_permonth * 365;
  return item?.pay_permonth * lastYearMonth;
};

// Helper function to calculate long term period
const calcLongTermPeriod = (item, index) => {
  if (index >= Math.ceil(item?.period)) return 0;
  return item?.pay_permonth * 12;
};

// Helper function to calculate credit card period
const calcCreditCardPeriod = (item, index) => {
  let period = item?.creditor_items?.length;
  let year = Math.floor(period / 12);
  let lastYearMonth = period % 12;
  if (index >= Math.ceil(period / 12)) return 0;
  if (index < year) return 12;
  return lastYearMonth;
};

// Build headers for Excel export
const buildExcelHeaders = (userData, balanceData, creditCardPeriod, educationData, retireData) => {
  const headers = [
    { key: "age", label: "อายุ", width: 10 },
    { key: "asset_invest", label: "สินทรัพย์เพื่อการลงทุนสุทธิ", width: 25 },
    { key: "total_income", label: "รวมรายได้", width: 20 },
    { key: "salary", label: "เงินเดือน", width: 20 },
    { key: "other_income", label: "รายได้อื่นๆ", width: 20 },
    {
      key: "total_expense",
      label: userData?.is_premium ? "รวมรายจ่ายต่อปี" : "รายจ่าย",
      width: 20,
    },
  ];

  if (userData?.is_premium) {
    headers.push(
      { key: "variable_expense", label: "รายจ่ายผันแปร", width: 20 },
      { key: "fixed_expense", label: "รายจ่ายคงที่", width: 20 }
    );
  }

  headers.push(
    { key: "remaining", label: "คงเหลือ", width: 20 },
    { key: "return_invest", label: "ผลตอบแทนการลงทุน", width: 25 }
  );

  // Add debt columns dynamically
  balanceData?.debt_short_list
    ?.find((item) => item?.options_debt_short === "debt_shortterm_other")
    ?.short_term_others?.forEach((item) => {
      headers.push({
        key: `debt_shortterm_other_${item?.creditor_name}`,
        label: `${item?.creditor_name || merge_label_key["debt_shortterm_other"]} (-)`,
        width: 25,
      });
    });

  balanceData?.debt_short_list
    ?.find((item) => item?.options_debt_short === "debt_informal_shortterm")
    ?.informal_short_terms?.forEach((item) => {
      headers.push({
        key: `debt_informal_${item?.creditor_name}`,
        label: `${item?.creditor_name || merge_label_key["debt_informal_shortterm"]} (-)`,
        width: 25,
      });
    });

  balanceData?.debt_short_list
    ?.find((item) => item?.options_debt_short === "debt_shortterm")
    ?.short_terms?.forEach((item) => {
      headers.push({
        key: `debt_short_${item?.creditor_name}`,
        label: `${item?.creditor_name || merge_label_key["debt_shortterm"]} (-)`,
        width: 25,
      });
    });

  creditCardPeriod?.forEach((item) => {
    headers.push({
      key: `creditcard_${item?.creditor_name}`,
      label: `${item?.creditor_name || merge_label_key["debt_creditcard"]} (-)`,
      width: 25,
    });
  });

  balanceData?.debt_long_list
    ?.find((item) => item?.options_debt_long === "debt_car")
    ?.debt_long_cars?.forEach((item) => {
      headers.push({
        key: `debt_car_${item?.title_car}`,
        label: `${item?.title_car || merge_label_key["debt_car"]} (-)`,
        width: 25,
      });
    });

  balanceData?.debt_long_list
    ?.find((item) => item?.options_debt_long === "debt_place")
    ?.debt_long_places?.forEach((item) => {
      headers.push({
        key: `debt_place_${item?.address_place}`,
        label: `${item?.address_place || merge_label_key["debt_place"]} (-)`,
        width: 25,
      });
    });

  balanceData?.debt_long_list
    ?.find((item) => item?.options_debt_long === "debt_long_other")
    ?.debt_long_others?.forEach((item) => {
      headers.push({
        key: `debt_long_other_${item?.title}`,
        label: `${item?.title || merge_label_key["debt_long_other"]} (-)`,
        width: 25,
      });
    });

  if (retireData?.ishavekids && educationData?.length > 0) {
    educationData.forEach((item) => {
      headers.push({
        key: `education_${item?.name}`,
        label: `${item?.name} (-)`,
        width: 25,
      });
    });
  }

  return headers;
};

// Build data rows for Excel export (Before Plan)
const buildExcelDataBefore = (
  dataAge,
  investmentReturnCal,
  retireData,
  outcomeUreliableCal,
  outcomeReliableCal,
  outcomeDebt,
  outcomeChildEducation,
  balanceData,
  creditCardPeriod,
  educationData,
  userData
) => {
  return dataAge?.map((age, index) => {
    const row = {
      age: age,
      asset_invest: numeral(investmentReturnCal?.[index]?.asset_invest).format(
        "0,0.00"
      ),
      total_income: numeral(
        Number(retireData?.bf_plan_income?.[index] || 0) +
          Number(retireData?.bf_plan_income_other?.[index] || 0)
      ).format("0,0.00"),
      salary: numeral(retireData?.bf_plan_income?.[index]).format("0,0.00"),
      other_income: numeral(retireData?.bf_plan_income_other?.[index]).format(
        "0,0.00"
      ),
      total_expense: numeral(
        Number(outcomeUreliableCal?.[index] || 0) +
          Number(outcomeReliableCal?.[index] || 0) +
          Number(outcomeDebt?.[index] || 0) +
          (retireData?.ishavekids
            ? Number(outcomeChildEducation?.[index] || 0)
            : 0)
      ).format("0,0.00"),
    };

    if (userData?.is_premium) {
      row.variable_expense = numeral(outcomeUreliableCal?.[index]).format(
        "0,0.00"
      );
      row.fixed_expense = numeral(outcomeReliableCal?.[index]).format(
        "0,0.00"
      );
    }

    row.remaining = numeral(
      Number(retireData?.bf_plan_income?.[index] || 0) +
        Number(retireData?.bf_plan_income_other?.[index] || 0) -
        (Number(outcomeUreliableCal?.[index] || 0) +
          Number(outcomeReliableCal?.[index] || 0) +
          Number(outcomeDebt?.[index] || 0))
    ).format("0,0.00");

    row.return_invest = numeral(
      investmentReturnCal?.[index]?.return_invest
    ).format("0,0.00");

    // Add debt values
    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_shortterm_other")
      ?.short_term_others?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_shortterm_other_${item?.creditor_name}`] = numeral(
          value
        ).format("0,0.00");
      });

    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_informal_shortterm")
      ?.informal_short_terms?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterestInformal(item, index);
        row[`debt_informal_${item?.creditor_name}`] = numeral(value).format(
          "0,0.00"
        );
      });

    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_shortterm")
      ?.short_terms?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_short_${item?.creditor_name}`] = numeral(value).format(
          "0,0.00"
        );
      });

    creditCardPeriod?.forEach((item) => {
      let value = 0;
      if (item?.type_payment === "pay_full") {
        value =
          index === 0
            ? item?.pay_peryear
            : item?.pay_permonth * calcCreditCardPeriod(item, index);
      } else if (
        item?.type_payment === "pay_minimum" ||
        item?.type_payment === "pay_other"
      ) {
        value = item?.creditor_items
          ?.slice(12 * index, 12 * (index + 1))
          ?.reduce((acc, creditItem) => acc + creditItem?.total_min, 0);
      }
      row[`creditcard_${item?.creditor_name}`] = numeral(value).format(
        "0,0.00"
      );
    });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_car")
      ?.debt_long_cars?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_car_${item?.title_car}`] = numeral(value).format("0,0.00");
      });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_place")
      ?.debt_long_places?.forEach((item) => {
        const value = calcLongTermPeriod(item, index);
        row[`debt_place_${item?.address_place}`] = numeral(value).format(
          "0,0.00"
        );
      });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_long_other")
      ?.debt_long_others?.forEach((item) => {
        const value = calcLongTermPeriod(item, index);
        row[`debt_long_other_${item?.title}`] = numeral(value).format(
          "0,0.00"
        );
      });

    if (retireData?.ishavekids && educationData?.length > 0) {
      educationData.forEach((item) => {
        row[`education_${item?.name}`] = numeral(
          item?.education_items?.[index]?.sum_under_education || 0
        ).format("0,0.00");
      });
    }

    return row;
  });
};

// Build data rows for Excel export (After Plan)
const buildExcelDataAfter = (
  retireData,
  investmentReturnCalAF,
  outcomeUreliableCalAF,
  outcomeReliableCalAF,
  outcomeDebtAF,
  outcomeChildEducation,
  balanceData,
  creditCardPeriod,
  educationData,
  userData
) => {
  return retireData?.af_plan_age?.map((age, index) => {
    const row = {
      age: age,
      asset_invest: numeral(
        Number(investmentReturnCalAF?.[index]?.asset_invest || 0)
      ).format("0,0.00"),
      total_income: numeral(
        Number(retireData?.af_plan_income?.[index] || 0) +
          Number(retireData?.af_plan_income_other?.[index] || 0)
      ).format("0,0.00"),
      other_income: numeral(
        Number(retireData?.af_plan_income_other?.[index] || 0)
      ).format("0,0.00"),
      salary: numeral(retireData?.af_plan_income?.[index]).format("0,0.00"),
      total_expense: numeral(
        Number(outcomeUreliableCalAF?.[index] || 0) +
          Number(outcomeReliableCalAF?.[index] || 0) +
          Number(outcomeDebtAF?.[index] || 0) +
          (retireData?.ishavekids
            ? Number(outcomeChildEducation?.[index] || 0)
            : 0)
      ).format("0,0.00"),
    };

    if (userData?.is_premium) {
      row.variable_expense = numeral(outcomeUreliableCalAF?.[index]).format(
        "0,0.00"
      );
      row.fixed_expense = numeral(outcomeReliableCalAF?.[index]).format(
        "0,0.00"
      );
    }

    row.remaining = numeral(
      retireData?.af_plan_income?.[index] +
        Number(retireData?.af_plan_income_other?.[index] || 0) -
        (Number(outcomeUreliableCalAF?.[index] || 0) +
          Number(outcomeReliableCalAF?.[index] || 0) +
          Number(outcomeDebtAF?.[index] || 0) +
          (retireData?.ishavekids
            ? Number(outcomeChildEducation?.[index] || 0)
            : 0))
    ).format("0,0.00");

    row.return_invest = numeral(
      Number(investmentReturnCalAF?.[index]?.return_invest || 0)
    ).format("0,0.00");

    // Add debt values
    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_shortterm_other")
      ?.short_term_others?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_shortterm_other_${item?.creditor_name}`] = numeral(
          value
        ).format("0,0.00");
      });

    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_informal_shortterm")
      ?.informal_short_terms?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterestInformal(item, index);
        row[`debt_informal_${item?.creditor_name}`] = numeral(value).format(
          "0,0.00"
        );
      });

    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_shortterm")
      ?.short_terms?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_short_${item?.creditor_name}`] = numeral(value).format(
          "0,0.00"
        );
      });

    creditCardPeriod?.forEach((item) => {
      let value = 0;
      if (item?.type_payment === "pay_full") {
        value =
          index === 0
            ? item?.pay_peryear
            : item?.pay_permonth * calcCreditCardPeriod(item, index);
      } else if (
        item?.type_payment === "pay_minimum" ||
        item?.type_payment === "pay_other"
      ) {
        value = item?.creditor_items
          ?.slice(12 * index, 12 * (index + 1))
          ?.reduce((acc, creditItem) => acc + creditItem?.total_min, 0);
      }
      row[`creditcard_${item?.creditor_name}`] = numeral(value).format(
        "0,0.00"
      );
    });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_car")
      ?.debt_long_cars?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_car_${item?.title_car}`] = numeral(value).format("0,0.00");
      });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_place")
      ?.debt_long_places?.forEach((item) => {
        const value = calcLongTermPeriod(item, index);
        row[`debt_place_${item?.address_place}`] = numeral(value).format(
          "0,0.00"
        );
      });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_long_other")
      ?.debt_long_others?.forEach((item) => {
        const value = calcLongTermPeriod(item, index);
        row[`debt_long_other_${item?.title}`] = numeral(value).format(
          "0,0.00"
        );
      });

    if (retireData?.ishavekids && educationData?.length > 0) {
      educationData.forEach((item) => {
        row[`education_${item?.name}`] = numeral(
          Number(item?.education_items?.[index]?.sum_under_education || 0)
        ).format("0,0.00");
      });
    }

    return row;
  });
};

// Export function for Before Plan Excel
export const exportToExcelBefore = (
  dataAge,
  investmentReturnCal,
  retireData,
  outcomeUreliableCal,
  outcomeReliableCal,
  outcomeDebt,
  outcomeChildEducation,
  balanceData,
  creditCardPeriod,
  educationData,
  userData
) => {
  const headers = buildExcelHeaders(
    userData,
    balanceData,
    creditCardPeriod,
    educationData,
    retireData
  );
  const data = buildExcelDataBefore(
    dataAge,
    investmentReturnCal,
    retireData,
    outcomeUreliableCal,
    outcomeReliableCal,
    outcomeDebt,
    outcomeChildEducation,
    balanceData,
    creditCardPeriod,
    educationData,
    userData
  );

  return { headers, data };
};

// Export function for After Plan Excel
export const exportToExcelAfter = (
  retireData,
  investmentReturnCalAF,
  outcomeUreliableCalAF,
  outcomeReliableCalAF,
  outcomeDebtAF,
  outcomeChildEducation,
  balanceData,
  creditCardPeriod,
  educationData,
  userData
) => {
  const headers = buildExcelHeaders(
    userData,
    balanceData,
    creditCardPeriod,
    educationData,
    retireData
  );
  const data = buildExcelDataAfter(
    retireData,
    investmentReturnCalAF,
    outcomeUreliableCalAF,
    outcomeReliableCalAF,
    outcomeDebtAF,
    outcomeChildEducation,
    balanceData,
    creditCardPeriod,
    educationData,
    userData
  );

  return { headers, data };
};

// Build data rows for Excel export (Sensitive Analysis)
const buildExcelDataSensitive = (
  retireData,
  investmentReturnCalSensitive,
  outcomeUreliableCalAF,
  outcomeReliableCalAF,
  outcomeDebtAF,
  outcomeChildEducation,
  balanceData,
  creditCardPeriod,
  educationData,
  userData
) => {
  return retireData?.af_plan_age?.map((age, index) => {
    const row = {
      age: age,
      asset_invest: numeral(
        Number(investmentReturnCalSensitive?.[index]?.asset_invest || 0)
      ).format("0,0.00"),
      total_income: numeral(
        Number(retireData?.af_plan_income?.[index] || 0) +
          Number(retireData?.af_plan_income_other?.[index] || 0)
      ).format("0,0.00"),
      other_income: numeral(
        Number(retireData?.af_plan_income_other?.[index] || 0)
      ).format("0,0.00"),
      salary: numeral(retireData?.af_plan_income?.[index]).format("0,0.00"),
      total_expense: numeral(
        Number(outcomeUreliableCalAF?.[index] || 0) +
          Number(outcomeReliableCalAF?.[index] || 0) +
          Number(outcomeDebtAF?.[index] || 0) +
          (retireData?.ishavekids
            ? Number(outcomeChildEducation?.[index] || 0)
            : 0)
      ).format("0,0.00"),
    };

    if (userData?.is_premium) {
      row.variable_expense = numeral(outcomeUreliableCalAF?.[index]).format(
        "0,0.00"
      );
      row.fixed_expense = numeral(outcomeReliableCalAF?.[index]).format(
        "0,0.00"
      );
    }

    row.remaining = numeral(
      retireData?.af_plan_income?.[index] +
        Number(retireData?.af_plan_income_other?.[index] || 0) -
        (Number(outcomeUreliableCalAF?.[index] || 0) +
          Number(outcomeReliableCalAF?.[index] || 0) +
          Number(outcomeDebtAF?.[index] || 0) +
          (retireData?.ishavekids
            ? Number(outcomeChildEducation?.[index] || 0)
            : 0))
    ).format("0,0.00");

    row.return_invest = numeral(
      Number(investmentReturnCalSensitive?.[index]?.return_invest || 0)
    ).format("0,0.00");

    // Add debt values (same as after plan)
    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_shortterm_other")
      ?.short_term_others?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_shortterm_other_${item?.creditor_name}`] = numeral(
          value
        ).format("0,0.00");
      });

    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_informal_shortterm")
      ?.informal_short_terms?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterestInformal(item, index);
        row[`debt_informal_${item?.creditor_name}`] = numeral(value).format(
          "0,0.00"
        );
      });

    balanceData?.debt_short_list
      ?.find((item) => item?.options_debt_short === "debt_shortterm")
      ?.short_terms?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_short_${item?.creditor_name}`] = numeral(value).format(
          "0,0.00"
        );
      });

    creditCardPeriod?.forEach((item) => {
      let value = 0;
      if (item?.type_payment === "pay_full") {
        value =
          index === 0
            ? item?.pay_peryear
            : item?.pay_permonth * calcCreditCardPeriod(item, index);
      } else if (
        item?.type_payment === "pay_minimum" ||
        item?.type_payment === "pay_other"
      ) {
        value = item?.creditor_items
          ?.slice(12 * index, 12 * (index + 1))
          ?.reduce((acc, creditItem) => acc + creditItem?.total_min, 0);
      }
      row[`creditcard_${item?.creditor_name}`] = numeral(value).format(
        "0,0.00"
      );
    });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_car")
      ?.debt_long_cars?.forEach((item) => {
        const value =
          item?.period === "Infinity"
            ? item?.pay_permonth * 12
            : calcPeriodInterest(item, index);
        row[`debt_car_${item?.title_car}`] = numeral(value).format("0,0.00");
      });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_place")
      ?.debt_long_places?.forEach((item) => {
        const value = calcLongTermPeriod(item, index);
        row[`debt_place_${item?.address_place}`] = numeral(value).format(
          "0,0.00"
        );
      });

    balanceData?.debt_long_list
      ?.find((item) => item?.options_debt_long === "debt_long_other")
      ?.debt_long_others?.forEach((item) => {
        const value = calcLongTermPeriod(item, index);
        row[`debt_long_other_${item?.title}`] = numeral(value).format(
          "0,0.00"
        );
      });

    if (retireData?.ishavekids && educationData?.length > 0) {
      educationData.forEach((item) => {
        row[`education_${item?.name}`] = numeral(
          Number(item?.education_items?.[index]?.sum_under_education || 0)
        ).format("0,0.00");
      });
    }

    return row;
  });
};

// Export function for Sensitive Analysis Excel
export const exportToExcelSensitive = (
  retireData,
  investmentReturnCalSensitive,
  outcomeUreliableCalAF,
  outcomeReliableCalAF,
  outcomeDebtAF,
  outcomeChildEducation,
  balanceData,
  creditCardPeriod,
  educationData,
  userData
) => {
  const headers = buildExcelHeaders(
    userData,
    balanceData,
    creditCardPeriod,
    educationData,
    retireData
  );
  const data = buildExcelDataSensitive(
    retireData,
    investmentReturnCalSensitive,
    outcomeUreliableCalAF,
    outcomeReliableCalAF,
    outcomeDebtAF,
    outcomeChildEducation,
    balanceData,
    creditCardPeriod,
    educationData,
    userData
  );

  return { headers, data };
};
